import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // Import default styles
import ReactPaginate from "react-paginate";
import { Button } from "react-bootstrap";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

function ImageList() {
  const history = useHistory();
  const location = useLocation();
  const photos = location.state.photos;
  const category = location.state.category;

  const [currentPage, setCurrentPage] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0); // Track the current photo index
  const itemsPerPage = 9;
  const pageCount = Math.ceil(photos.length / itemsPerPage);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
    setIsOpen(false); // Close lightbox when changing pages
  };

  const displayPhotos = photos.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  // Handle image click to open lightbox
  const handleImageClick = (index) => {
    setPhotoIndex(index + currentPage * itemsPerPage); // Adjust index for pagination
    setIsOpen(true);
  };

  return (
    <>
      <Header />
      <Banner title="Gallery" image="banners/banner-gallery.jpg" />
      <div className="container" style={{ padding: "3rem" }}>
        <div className="row">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "3rem",
            }}
          >
            <h4>{category}</h4>
            {/* <Button onClick={() => history.goBack()}>Go Back</Button> */}
          </div>

          {displayPhotos.map((item, index) => (
            <div key={item.id} className="col-lg-4 mb-4">
              <div className="card">
                <img
                  className="card-img-top swaraimage1"
                  src={item.Image}
                  alt={item.Description}
                  onClick={() => handleImageClick(index)}
                  style={{ cursor: "pointer" }}
                />
                <div className="card-body">
                  <p
                    style={{ fontSize: "15px", fontWeight: "bold" }}
                    className="card-title"
                  >
                    {item.Description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <ReactPaginate
          previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
          previousClassName={"previous"}
          nextClassName={"next"}
          disabledClassName={"disabled"}
        />

        {isOpen && (
          <Lightbox
            mainSrc={photos[photoIndex].Image}
            nextSrc={photos[(photoIndex + 1) % photos.length].Image}
            prevSrc={photos[(photoIndex + photos.length - 1) % photos.length].Image}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + photos.length - 1) % photos.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % photos.length)
            }
            imageTitle={photos[photoIndex].Description}
          />
        )}
      </div>

      <Footer />
    </>
  );
}

export default ImageList;